import { FC } from 'react';

import { useFormDataQuery } from '@/api/getters';
import { BUSINESS_TYPE } from '@/api/types';
import CompaniesCompanyInputs from '@/features/v2/summaryForms/surveyTwo/Forms/CompaniesCompanyInputs';
import CompaniesPersonInputs from '@/features/v2/summaryForms/surveyTwo/Forms/CompaniesPersonInputs';

interface Props {
  isCoOwner?: boolean;
  prefix?: 'owner' | `coowners.${number}`;
  index?: number;
  recipientType: BUSINESS_TYPE | null;
  defaultValues: {
    phone: string;
    email: string;
    first_name: string;
    last_name: string;
  };
}

const CompaniesInputs: FC<Props> = ({
  isCoOwner,
  prefix,
  index,
  defaultValues,
}) => {
  const { data } = useFormDataQuery();

  if (!isCoOwner) {
    return (
      <CompaniesCompanyInputs
        prefix={prefix}
        businessType={data?.payload?.data?.owner?.business_type}
      />
    );
  }

  return (
    <CompaniesPersonInputs
      prefix={prefix}
      index={index}
      defaultValues={defaultValues}
    />
  );
};

export default CompaniesInputs;
